import { graphql } from '../generated';

export const GET_PLANS = graphql(`
  query GetPlans {
    plans {
      id
      name
      priceCents
      includedPodHours
      podsAtATime
      extraPodHourCents
      lines
    }
  }
`);

export const GET_PLAN_CHANGE_PREVIEW = graphql(`
  query GetPlanChangePreview($input: PlanChangePreviewInput!) {
    planChangePreview(input: $input) {
      plan
      isUpgrade
      dueTodayCents
      currency
      nextAmountCents
      nextBilledAt
      takesEffectAt
    }
  }
`);
